import { ITypeUser } from '../types/typeUsers.type';
import $http from '../services/AxiosInstance';

class TypeUsersRepository {
  static async getTypeUsers():Promise<ITypeUser[] | undefined> {
    try {
      const response = await $http.get('/typeUsers' );
      if (response.data?.typeUsers){
        return response.data.typeUsers;
      }
    } catch (errors: any) {
      throw Error;
    }
  }
}

export default TypeUsersRepository;
